@if (table.ready$ | async) {
  <table mat-table [dataSource]="table.items$" [trackBy]="tableService.trackEntity" matSort (matSortChange)="tableService.handleMatSortChange(table, $event)">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.name.name }}</th>
      <td mat-cell *matCellDef="let discount">{{ discount.name }}</td>
    </ng-container>
    <ng-container matColumnDef="percentage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.percentage.name }}</th>
      <td mat-cell *matCellDef="let discount">{{ discount.percentage }}%</td>
    </ng-container>
    <ng-container matColumnDef="period">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.period.name }}</th>
      <td mat-cell *matCellDef="let discount">{{ discount.startTime | date }} - {{ discount.endTime | date }}</td>
    </ng-container>
    <ng-container matColumnDef="scope">
      <th mat-header-cell *matHeaderCellDef>{{ table.columns.scope.name }}</th>
      <td mat-cell *matCellDef="let discount">All Clusters</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
    <tr mat-row *matRowDef="let discount; columns: table.displayedColumns"></tr>
  </table>
} @else {
  <tp-spinner/>
}
